import { Checkbox } from '@vnetwork/ui/primitives';
import { Alert } from '@vnetwork/ui/feedback';
import { PERMISSION_ACTIONS, type PermissionAction } from '@/api/teams';
import { toggleAction } from '../shared';

interface PermissionCheckboxesProps {
  value: string[];
  onChange: (next: string[]) => void;
}

// Management actions render in the grid; the exclusive read-only "Report" role is
// pulled out below its own explainer.
const MANAGEMENT_ACTIONS = PERMISSION_ACTIONS.filter((a) => a.key !== 'report');
const REPORT_ACTION = PERMISSION_ACTIONS.find((a) => a.key === 'report');

/** Permission action grid + the exclusive Report read-only role, shared by the add/edit dialogs. */
export function PermissionCheckboxes({ value, onChange }: PermissionCheckboxesProps) {
  const check = (key: PermissionAction) => (
    <label style={{ display: 'inline-flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
      <Checkbox checked={value.includes(key)} onCheckedChange={() => onChange(toggleAction(value, key))} />
      <span style={{ fontSize: 14 }}>{PERMISSION_ACTIONS.find((a) => a.key === key)?.label ?? key}</span>
    </label>
  );

  return (
    <div style={{ display: 'grid', gap: 'var(--vn-space-3)' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 12 }}>
        {MANAGEMENT_ACTIONS.map((a) => <span key={a.key}>{check(a.key)}</span>)}
      </div>

      {REPORT_ACTION && (
        <>
          <Alert tone="info">
            <strong>Report</strong> grants read-only access to usage reports — overview, analytics and
            usage only. The member cannot view or manage any other features (domains, settings, etc.).
            It is exclusive: selecting it clears the permissions above.
          </Alert>
          {check(REPORT_ACTION.key)}
        </>
      )}
    </div>
  );
}
